import React, { useState } from 'react'
import '../css/Admin/SidePanel.css';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Logo from '../assets/logo.png';
import { useLocation } from 'react-router-dom';
import { HiOutlineBanknotes, HiOutlineAcademicCap } from 'react-icons/hi2';
import { PiExam, PiNotepadLight, PiTreeStructure, PiChalkboardTeacher, PiStudent } from 'react-icons/pi';
import { SiGoogleclassroom } from 'react-icons/si';
import { MdAddTask, MdOutlineClass, MdDirectionsBus, MdEmojiTransportation, MdHomeWork, MdManageSearch, MdMeetingRoom, MdOutlineAssignment, MdOutlineAssignmentInd, MdOutlineDownloading, MdOutlineLocalLibrary } from 'react-icons/md';
import { AiOutlineBook, AiOutlineQuestionCircle, AiOutlineUsergroupAdd } from 'react-icons/ai';
import { IoCreateOutline, IoIdCardOutline, IoLibraryOutline } from 'react-icons/io5';
import { LuCalendarClock, LuRoute, LuHotel, LuClipboardList } from 'react-icons/lu';
import { BiSolidBookAdd, BiUserCheck } from 'react-icons/bi';
import { TbReport, TbReportAnalytics } from 'react-icons/tb';
import { BsBookmarkPlus, BsCalendar3, BsJournalBookmark, BsPersonAdd } from 'react-icons/bs';
import { FaBusinessTime } from 'react-icons/fa';
import { HiOutlineDocumentReport } from 'react-icons/hi';


const SidePanel = ({ isInsAdmin, userData }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    // localStorage.removeItem('userData');
    if (isInsAdmin) {
      localStorage.removeItem('isInsAdmin', 'true');
      localStorage.removeItem('userData');

      if(userData.role == 'SupAdmin')
      navigate('/institute-login');
    else
      navigate('/staff-login');
    }
    window.location.reload();
  }


  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };


  // active items & subitems
  const generalSettingsPaths = [
    '/admin/profile',
    '/admin/academic-year',
    '/admin/account-detail',
  ];


  const classesPaths = [
    '/admin/all-classes',
    '/admin/new-class',
  ];


  const subjectsPaths = [
    '/admin/class-subjects',
    '/admin/assign-subjects',
  ];

  const studentsPaths = [
    '/admin/all-students',
    '/admin/add-student',
    '/admin/student-icards',
    '/admin/registration-list'
    // '/admin/print-student-list',
  ];


  const employeesPaths = [
    '/admin/all-employees',
    '/admin/add-employee',
    '/admin/staff-icards',
  ];


  const attendancePaths = [
    '/admin/students-attendance',
    '/admin/employees-attendance',
    '/admin/students-attendance-report',
    '/admin/employees-attendance-report'
  ];


  const timeTablePaths = [
    '/admin/create-time-table',
    '/admin/teacher-allocation',
    '/admin/class-time-table',
    // '/admin/teacher-time-table',
  ];


  const visitsPaths = [
    '/admin/appointments',
    '/admin/visits',
  ];


  const feesPaths = [
    '/admin/collect-fees',
    // '/admin/fees-reports',
    '/admin/fee-particular',
    '/admin/fee-structure',
    '/admin/fee-report'
  ];


    const homeworkPaths = [
    '/admin/add-homework',
    '/admin/homework-list',
    '/admin/homework-report',
  ]


  const studymaterialPaths = [
    '/admin/upload-content',
    '/admin/assignment',
    '/admin/syllabus',
  ]


  const lessonplanPaths = [
    '/admin/lesson',
    '/admin/topic',
    '/admin/plan-overview',
  ]

  const examPaths = [
    '/admin/exam-type',
    '/admin/exam-setup',
    '/admin/exam-schedule',
    '/admin/exam-attendance',
    '/admin/offline-exam-report',
    '/admin/offline-report-card',
'/admin/prepare-report-card'    
  ]


    const onlineExamPaths = [
    '/admin/question-group',
    '/admin/question-bank',
    '/admin/create-exam',
    '/admin/online-exam-report'
  ]


  const leavePaths = [
    '/admin/apply-leave',
    '/admin/approve-leave-request',
    '/admin/leave-define',
  ]


    const libraryPaths = [
    '/admin/add-book',
    '/admin/book-list',
    '/admin/add-member',
    '/admin/issue-return',
  ]


      const transportPaths = [
    '/admin/add-routes',
    '/admin/add-vehicle',
    '/admin/assign-vehicle',
  ]

      const hostelPaths = [
    '/admin/add-hostel',
    '/admin/room-type',
    '/admin/hostel-rooms',
    '/admin/assign-room',
  ]


  const isGeneralActive = () => generalSettingsPaths.includes(location.pathname);
  const isClassesActive = () => classesPaths.includes(location.pathname);
  const isSubjectsActive = () => subjectsPaths.includes(location.pathname);
  const isStudentsActive = () => studentsPaths.includes(location.pathname);
  const isEmployeeActive = () => employeesPaths.includes(location.pathname);
  const isAttendanceActive = () => attendancePaths.includes(location.pathname);
  const isTimeTableActive = () => timeTablePaths.includes(location.pathname);
  const isVisitsActive = () => visitsPaths.includes(location.pathname);
  const isFeesActive = () => feesPaths.includes(location.pathname);
  const isHomeworkActive = () => homeworkPaths.includes(location.pathname);
  const isLessonplanActive = () => lessonplanPaths.includes(location.pathname);
  const isstudymaterialActive = () => studymaterialPaths.includes(location.pathname);
  const isexamActive = () => examPaths.includes(location.pathname);
  const isonlineExamActive = () => onlineExamPaths.includes(location.pathname);
  const isLeaveActive = () => leavePaths.includes(location.pathname);

  const isLibraryActive = () => libraryPaths.includes(location.pathname);

    const isTransportActive = () => transportPaths.includes(location.pathname);
  const isHostelActive = () => hostelPaths.includes(location.pathname);


  return (
    <>
      <div className={`sidepanel-area animate__animated animate__fadeInLeft ${collapsed ? "" : "collapsed"}`}>

        <div className='my-2 sidepanel-logo-area'>
          <img src={Logo} className='sidepanel-logo' alt='Logo Sidepanel' />
          <p className='align-content-center fw-bold my-0 ms-2 sidepanel-logo-text'>K C Public School</p>
        </div>

        {isInsAdmin && (
          <div className='mt-3'>


            {/* Dashboard */}
            {/* ------------------------------------- */}
            <p className='sidepanel-divider'>Modules</p>
            <p className={`sidepanel-item ${isActive('/admin/dashboard') ? 'active' : ''}`} onClick={() => { navigate('/admin/dashboard'); setCollapsed(false) }}><i class="fa-solid fa-home"></i><Link className='sidepanel-text'>Dashboard</Link></p>

{ (userData.role === 'Librarian' || userData.role === 'Transport' || userData.role === 'Hostel') && (
  <>  <p className={`sidepanel-item ${isActive('/admin/profile') ? 'active' : ''}`} 
     onClick={() => { navigate('/admin/profile'); setCollapsed(false) }}>
    <i className="fa-regular fa-user"></i>
    <Link className='sidepanel-text'>Manage Profile</Link>
  </p>

<p
                  className={`sidepanel-item ${isActive('/admin/apply-leave') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/apply-leave');
                  }}
                >
                  <LuHotel size={21} />
                  <Link className="sidepanel-text">Apply Leave</Link>
                </p>
                </>

)}


{userData.role == 'Librarian' && 
<>
            <div className={`sidepanel-item ${isLibraryActive() ? 'active' : ''}`} onClick={() => toggleDropdown('library')}>
              <IoLibraryOutline size={21} />
              <span className='sidepanel-text'>Library</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'library' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'library' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/add-book') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-book'); setCollapsed(false) }}><BiSolidBookAdd size={21} /><Link className='sidepanel-text'>Add Book</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/book-list') ? 'active' : ''}`} onClick={() => { navigate('/admin/book-list'); setCollapsed(false) }}><MdOutlineLocalLibrary size={21} /><Link className='sidepanel-text'>Book List</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/add-member') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-member'); setCollapsed(false) }}><BsPersonAdd size={21} /><Link className='sidepanel-text'>Add Member</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/issue-return') ? 'active' : ''}`} onClick={() => { navigate('/admin/issue-return'); setCollapsed(false) }}><AiOutlineBook size={21} /><Link className='sidepanel-text'>Issue/ Return Book</Link></p>
              </div>
            )}

            </>
}



{/* {userData.role == 'Hostel' && 
<>
            <div className={`sidepanel-item ${isHostelActive() ? 'active' : ''}`} onClick={() => toggleDropdown('hostel')}>
              <LuHotel size={21} />
              <span className='sidepanel-text'>Hostel</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'hostel' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'hostel' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/add-hostel') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-hostel'); setCollapsed(false) }}><LuHotel size={21} /><Link className='sidepanel-text'>Add Hostel</Link></p>
              
                <p className={`sidepanel-item ${isActive('/admin/hostel-rooms') ? 'active' : ''}`} onClick={() => { navigate('/admin/hostel-rooms'); setCollapsed(false) }}><MdMeetingRoom size={21} /><Link className='sidepanel-text'>Hostel Rooms</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/assign-rooms') ? 'active' : ''}`} onClick={() => { navigate('/admin/assign-rooms'); setCollapsed(false) }}><MdOutlineAssignmentInd size={21} /><Link className='sidepanel-text'>Assign Rooms</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/hostel-report') ? 'active' : ''}`} onClick={() => { navigate('/admin/hostel-report'); setCollapsed(false) }}><HiOutlineDocumentReport size={21} /><Link className='sidepanel-text'>Hostel Report</Link></p>
              </div>
            )}
            </>
} */}


{userData.role == 'Transport' && 
<>
            <div className={`sidepanel-item ${isTransportActive() ? 'active' : ''}`} onClick={() => toggleDropdown('transport')}>
              <MdEmojiTransportation size={21} />
              <span className='sidepanel-text'>Transport</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'transport' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'transport' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/add-routes') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-routes'); setCollapsed(false) }}><LuRoute size={21} /><Link className='sidepanel-text'>Routes</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/add-vehicle') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-vehicle'); setCollapsed(false) }}><MdDirectionsBus size={21} /><Link className='sidepanel-text'>Vehicle</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/assign-vehicle') ? 'active' : ''}`} onClick={() => { navigate('/admin/assign-vehicle'); setCollapsed(false) }}><FaBusinessTime size={21} /><Link className='sidepanel-text'>Assign Vehicle</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/transport-report') ? 'active' : ''}`} onClick={() => { navigate('/admin/transport-report'); setCollapsed(false) }}><HiOutlineDocumentReport size={21} /><Link className='sidepanel-text'>Transport Report</Link></p>
              </div>
            )}

            </>
}


{(userData.role == 'SupAdmin' || userData.role == 'Teacher') && 
<>


            {/* Library modules */}
{userData.role != 'Teacher' &&
<>

            <div className={`sidepanel-item ${isLibraryActive() ? 'active' : ''}`} onClick={() => toggleDropdown('library')}>
              <IoLibraryOutline size={21} />
              <span className='sidepanel-text'>Library</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'library' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'library' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/add-book') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-book'); setCollapsed(false) }}><BiSolidBookAdd size={21} /><Link className='sidepanel-text'>Add Book</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/book-list') ? 'active' : ''}`} onClick={() => { navigate('/admin/book-list'); setCollapsed(false) }}><MdOutlineLocalLibrary size={21} /><Link className='sidepanel-text'>Book List</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/add-member') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-member'); setCollapsed(false) }}><BsPersonAdd size={21} /><Link className='sidepanel-text'>Add Member</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/issue-return') ? 'active' : ''}`} onClick={() => { navigate('/admin/issue-return'); setCollapsed(false) }}><AiOutlineBook size={21} /><Link className='sidepanel-text'>Issue/ Return Book</Link></p>
              </div>
            )}


            {/* Transport modules */}
            <div className={`sidepanel-item ${isTransportActive() ? 'active' : ''}`} onClick={() => toggleDropdown('transport')}>
              <MdEmojiTransportation size={21} />
              <span className='sidepanel-text'>Transport</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'transport' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'transport' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/add-routes') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-routes'); setCollapsed(false) }}><LuRoute size={21} /><Link className='sidepanel-text'>Routes</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/add-vehicle') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-vehicle'); setCollapsed(false) }}><MdDirectionsBus size={21} /><Link className='sidepanel-text'>Vehicle</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/assign-vehicle') ? 'active' : ''}`} onClick={() => { navigate('/admin/assign-vehicle'); setCollapsed(false) }}><FaBusinessTime size={21} /><Link className='sidepanel-text'>Assign Vehicle</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/transport-report') ? 'active' : ''}`} onClick={() => { navigate('/admin/transport-report'); setCollapsed(false) }}><HiOutlineDocumentReport size={21} /><Link className='sidepanel-text'>Transport Report</Link></p>
              </div>
            )}


            {/* Hostel modules */}
            {/* <div className={`sidepanel-item ${isHostelActive() ? 'active' : ''}`} onClick={() => toggleDropdown('hostel')}>
              <LuHotel size={21} />
              <span className='sidepanel-text'>Hostel</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'hostel' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div> */}
            {openDropdown === 'hostel' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/add-hostel') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-hostel'); setCollapsed(false) }}><LuHotel size={21} /><Link className='sidepanel-text'>Add Hostel</Link></p>
             
                <p className={`sidepanel-item ${isActive('/admin/hostel-rooms') ? 'active' : ''}`} onClick={() => { navigate('/admin/hostel-rooms'); setCollapsed(false) }}><MdMeetingRoom size={21} /><Link className='sidepanel-text'>Hostel Rooms</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/assign-rooms') ? 'active' : ''}`} onClick={() => { navigate('/admin/assign-rooms'); setCollapsed(false) }}><MdOutlineAssignmentInd size={21} /><Link className='sidepanel-text'>Assign Rooms</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/hostel-report') ? 'active' : ''}`} onClick={() => { navigate('/admin/hostel-report'); setCollapsed(false) }}><HiOutlineDocumentReport size={21} /><Link className='sidepanel-text'>Hostel Report</Link></p>
              </div>
            )}

</>
}


            {/* Academics */}
            {/* ------------------------------------- */}
                                    {userData.role != 'Teacher' &&
<>
            <p className='sidepanel-divider'>Academics</p>
            {/* Classes */}
            <div className={`sidepanel-item ${isClassesActive() ? 'active' : ''}`} onClick={() => toggleDropdown('classes')}>
              <i className="fa-solid fa-graduation-cap"></i>
              <span className='sidepanel-text'>Classes</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'classes' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'classes' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/all-classes') ? 'active' : ''}`} onClick={() => { navigate('/admin/all-classes'); setCollapsed(false) }}><SiGoogleclassroom size={21} /><Link className='sidepanel-text'>All Classes</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/new-class') ? 'active' : ''}`} onClick={() => { navigate('/admin/assign-class-teacher'); setCollapsed(false) }}><MdOutlineAssignment size={21} /><Link className='sidepanel-text'>Assign Class Teacher</Link></p>
              </div>
            )}

            {/* subjects */}
            <div className={`sidepanel-item ${isSubjectsActive() ? 'active' : ''}`} onClick={() => toggleDropdown('subjects')}>
              <i className="fa-solid fa-book"></i>
              <span className='sidepanel-text'>Subjects</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'subjects' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'subjects' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/class-subjects') ? 'active' : ''}`} onClick={() => { navigate('/admin/class-subjects'); setCollapsed(false) }}><MdOutlineClass size={21} /><Link className='sidepanel-text'>All Subjects</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/assign-subjects') ? 'active' : ''}`} onClick={() => { navigate('/admin/assign-subjects'); setCollapsed(false) }}><MdOutlineAssignment size={21} /><Link className='sidepanel-text'>Assign Subjects</Link></p>
              </div>
            )}
</> }

            {/* Attendance */}
            <div className={`sidepanel-item ${isAttendanceActive() ? 'active' : ''}`} onClick={() => toggleDropdown('attendance')}>
              <i className="fa-solid fa-circle-check"></i>
              <span className='sidepanel-text'>Attendance</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'attendance' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'attendance' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/students-attendance') ? 'active' : ''}`} onClick={() => { navigate('/admin/students-attendance'); setCollapsed(false) }}><BiUserCheck size={22} /><Link className='sidepanel-text'>Student Attendance</Link></p>

{userData.role != 'Teacher' &&
                <p className={`sidepanel-item ${isActive('/admin/employees-attendance') ? 'active' : ''}`} onClick={() => { navigate('/admin/employees-attendance'); setCollapsed(false) }}><BiUserCheck size={22} /><Link className='sidepanel-text'>Employees Attendance</Link></p>}
                <p className={`sidepanel-item ${isActive('/admin/students-attendance-report') ? 'active' : ''}`} onClick={() => { navigate('/admin/students-attendance-report'); setCollapsed(false) }}><TbReport size={21} /><Link className='sidepanel-text'>Students Attendance Report</Link></p>
{/* {userData.role != 'Teacher' && */}
                <p className={`sidepanel-item ${isActive('/admin/employees-attendance-report') ? 'active' : ''}`} onClick={() => { navigate('/admin/employees-attendance-report'); setCollapsed(false) }}><TbReport size={21} /><Link className='sidepanel-text'>Employees Attendance Report</Link></p>
              </div>
            )}


            {/* time table */}
            {userData.role != 'Teacher' &&
<>
            <div className={`sidepanel-item ${isTimeTableActive() ? 'active' : ''}`} onClick={() => toggleDropdown('timeTable')}>
              <i className="fa-solid fa-calendar"></i>
              <span className='sidepanel-text'>Time Table</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'timeTable' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'timeTable' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/create-time-table') ? 'active' : ''}`} onClick={() => { navigate('/admin/create-time-table'); setCollapsed(false) }}><BsCalendar3 size={21} /><Link className='sidepanel-text'>Create Time Table</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/teacher-allocation') ? 'active' : ''}`} onClick={() => { navigate('/admin/teacher-allocation'); setCollapsed(false) }}><MdAddTask size={21} /><Link className='sidepanel-text'>Teacher Allocation</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/class-time-table') ? 'active' : ''}`} onClick={() => { navigate('/admin/class-time-table'); setCollapsed(false) }}><LuCalendarClock size={21} /><Link className='sidepanel-text'>Class Time Table</Link></p>
              </div>
            )}
</>          }

            {/* Study Material */}
            <div className={`sidepanel-item ${isstudymaterialActive() ? 'active' : ''}`} onClick={() => toggleDropdown('studymaterial')}>
              <i className="fa-solid fa-book"></i><span className="sidepanel-text">Study Material</span>
              <span className="float-end">
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'studymaterial' ? 'fa-chevron-up' : 'fa-chevron-down'}`} ></i>
              </span>
            </div>

            {openDropdown === 'studymaterial' && (
              <div className="sidepanel-submenu">
                <p
                  className={`sidepanel-item ${isActive('/admin/upload-content') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/upload-content');
                    setCollapsed(false);
                  }}
                >
                  <MdOutlineAssignment size={21} />
                  <Link className="sidepanel-text">Upload Content</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/assignment') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/assignment');
                    setCollapsed(false);
                  }}
                >
                  <BsBookmarkPlus size={21} />
                  <Link className="sidepanel-text">Assignments</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/syllabus') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/syllabus');
                    setCollapsed(false);
                  }}
                >
                  <IoLibraryOutline size={21} />
                  <Link className="sidepanel-text">Syllabus</Link>
                </p>
                                <p
                  className={`sidepanel-item ${isActive('/admin/other-downloads') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/other-downloads');
                    setCollapsed(false);
                  }}
                >
                  <MdOutlineDownloading size={21} />
                  <Link className="sidepanel-text">Other Downloads</Link>
                </p>
              </div>
            )}



            {/* Lesson Plan */}
            <div
              className={`sidepanel-item ${isLessonplanActive() ? 'active' : ''}`}
              onClick={() => toggleDropdown('lessonplan')}
            >
              <i className="fa-solid fa-chalkboard"></i>
              <span className="sidepanel-text">Lesson Plan</span>
              <span className="float-end">
                <i
                  className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'lessonplan' ? 'fa-chevron-up' : 'fa-chevron-down'
                    }`}
                ></i>
              </span>
            </div>
            {openDropdown === 'lessonplan' && (
              <div className="sidepanel-submenu">
                <p
                  className={`sidepanel-item ${isActive('/admin/lesson') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/lesson');
                    setCollapsed(false);
                  }}
                >
                  <BsBookmarkPlus size={21} />
                  <Link className="sidepanel-text">Lesson</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/topic') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/topic');
                    setCollapsed(false);
                  }}
                >
                  <MdOutlineAssignment size={21} />
                  <Link className="sidepanel-text">Topic</Link>
                </p>
                {/* <p
                  className={`sidepanel-item ${isActive('/admin/topic-overview') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/topic-overview');
                    setCollapsed(false);
                  }}
                >
                  <LuClipboardList size={21} />
                  <Link className="sidepanel-text">Topic Overview</Link>
                </p> */}
                <p
                  className={`sidepanel-item ${isActive('/admin/plan-overview') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/plan-overview');
                    setCollapsed(false);
                  }}
                >
                  <PiChalkboardTeacher size={21} />
                  <Link className="sidepanel-text">Plan Overview</Link>
                </p>
                {/* <p
                  className={`sidepanel-item ${isActive('/admin/lesson-plan-overview') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/lesson-plan-overview');
                    setCollapsed(false);
                  }}
                >
                  <TbReportAnalytics size={21} />
                  <Link className="sidepanel-text">Lesson Plan Overview</Link>
                </p> */}
              </div>
            )}


            {/* Student */}
            {/* ------------------------------------- */}
            <p className='sidepanel-divider'>Student</p>
            {/* students info */}
            <div className={`sidepanel-item ${isStudentsActive() ? 'active' : ''}`} onClick={() => toggleDropdown('students')}>
              <i className="fa-solid fa-users"></i>
              <span className='sidepanel-text'>Student Info</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'students' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'students' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/all-students') ? 'active' : ''}`} onClick={() => { navigate('/admin/all-students'); setCollapsed(false) }}><PiStudent size={22} /><Link className='sidepanel-text'>All Students</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/add-student') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-student'); setCollapsed(false) }}><AiOutlineUsergroupAdd size={22} /><Link className='sidepanel-text'>Add New</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/registration-list') ? 'active' : ''}`} onClick={() => { navigate('/admin/registration-list'); setCollapsed(false) }}><LuClipboardList size={21} /><Link className='sidepanel-text'>Registrations</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/student-icards') ? 'active' : ''}`} onClick={() => { navigate('/admin/student-icards'); setCollapsed(false) }}><IoIdCardOutline size={21} /><Link className='sidepanel-text'>Student ID Cards</Link></p>
              </div>
            )}


            {/* <p className={`sidepanel-item ${isActive('/admin/accounts') ? 'active' : ''}`} onClick={() => { navigate('/'); setCollapsed(false) }}><i class="fa-solid fa-building-columns"></i><Link className='sidepanel-text'>Accounts</Link></p> */}


            {/* fees */}
            {userData.role != 'Teacher' && <>

            <div className={`sidepanel-item ${isFeesActive() ? 'active' : ''}`} onClick={() => toggleDropdown('fees')}>
              <i className="fa-solid fa-receipt"></i>
              <span className='sidepanel-text'>Fees</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'fees' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'fees' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/collect-fees') ? 'active' : ''}`} onClick={() => { navigate('/admin/collect-fees'); setCollapsed(false) }}><PiChalkboardTeacher size={22} /><Link className='sidepanel-text'>Collect Fees</Link></p>
                {/* <p className={`sidepanel-item ${isActive('/admin/fees-reports') ? 'active' : ''}`} onClick={() => { navigate('/admin/fees-reports'); setCollapsed(false) }}><AiOutlineUsergroupAdd size={22} /><Link className='sidepanel-text'>Fees Report</Link></p> */}
                <p className={`sidepanel-item ${isActive('/admin/fee-particular') ? 'active' : ''}`} onClick={() => { navigate('/admin/fee-particular'); setCollapsed(false) }}><HiOutlineBanknotes size={21} /><Link className='sidepanel-text'>Fees Particulars</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/fee-structure') ? 'active' : ''}`} onClick={() => { navigate('/admin/fee-structure'); setCollapsed(false) }}><PiTreeStructure size={21} /><Link className='sidepanel-text'>Fees Structure</Link></p>
              </div>
            )}
</>}

            {/* Homework */}
            <div
              className={`sidepanel-item ${isHomeworkActive() ? 'active' : ''}`}
              onClick={() => toggleDropdown('homework')}
            >
              <i className="fa-solid fa-book-open"></i>
              <span className='sidepanel-text'>HomeWork</span>
              <span className='float-end'>
                <i
                  className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'homework' ? 'fa-chevron-up' : 'fa-chevron-down'
                    }`}
                ></i>
              </span>
            </div>
            {openDropdown === 'homework' && (
              <div className='sidepanel-submenu'>
                <p
                  className={`sidepanel-item ${isActive('/admin/add-homework') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/add-homework');
                    setCollapsed(false);
                  }}
                >
                  <MdHomeWork size={21} />
                  <Link className='sidepanel-text'>Add Homework</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/homework-list') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/homework-list');
                    setCollapsed(false);
                  }}
                >
                  <BsJournalBookmark size={21} />
                  <Link className='sidepanel-text'>Homework List</Link>
                </p>
                {/* <p
                  className={`sidepanel-item ${isActive('/admin/homework-report') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/homework-report');
                    setCollapsed(false);
                  }}
                >
                  <TbReport size={21} />
                  <Link className='sidepanel-text'>Homework Report</Link>
                </p> */}
              </div>
            )}


            {/* Remark */}
            <p className={`sidepanel-item ${isActive('/admin/student-remark') ? 'active' : ''}`} onClick={() => { navigate('/admin/student-remark'); setCollapsed(false) }}><i class="fa-solid fa-question"></i><Link className='sidepanel-text'>Remark</Link></p>


            {/* Exam */}
            {/* ------------------------------------- */}
            <p className="sidepanel-divider">Exam</p>
            <div
              className={`sidepanel-item ${isexamActive() ? 'active' : ''}`}
              onClick={() => toggleDropdown('exam')}
            >
              <PiExam size={21} />
              <span className="sidepanel-text">Examination</span>
              <span className="float-end">
                <i
                  className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'exam' ? 'fa-chevron-up' : 'fa-chevron-down'
                    }`}
                ></i>
              </span>
            </div>

            {openDropdown === 'exam' && (
              <div className="sidepanel-submenu">
             {userData.role != 'Teacher' &&
   <p
                  className={`sidepanel-item ${isActive('/admin/exam-type') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/exam-type');
                    setCollapsed(false);
                  }}
                >
                  <MdOutlineAssignment size={21} />
                  <Link className="sidepanel-text">Exam Type</Link>
                </p>

                }

                <p
                  className={`sidepanel-item ${isActive('/admin/exam-setup') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/exam-setup');
                    setCollapsed(false);
                  }}
                >
                  <BsBookmarkPlus size={21} />
                  <Link className="sidepanel-text">Exam Setup</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/exam-schedule') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/exam-schedule');
                    setCollapsed(false);
                  }}
                >
                  <LuCalendarClock size={21} />
                  <Link className="sidepanel-text">Exam Schedule</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/exam-attendance') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/exam-attendance');
                    setCollapsed(false);
                  }}
                >
                  <BiUserCheck size={21} />
                  <Link className="sidepanel-text">Exam Attendance</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/offline-exam-report') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/offline-exam-report');
                    setCollapsed(false);
                  }}
                >
                  <TbReport size={21} />
                  <Link className="sidepanel-text">Marks Entry</Link>
                </p>

                                <p
                  className={`sidepanel-item ${isActive('/admin/offline-report-card') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/offline-report-card');
                    setCollapsed(false);
                  }}
                >
                  <TbReportAnalytics size={21} />
                  <Link className="sidepanel-text">Report Card</Link>
                </p>


              </div>
            )}


{/* online exam */}
            <div
              className={`sidepanel-item ${isonlineExamActive() ? 'active' : ''}`}
              onClick={() => toggleDropdown('online')}
            >
              <PiExam size={21} />
              <span className="sidepanel-text">Online Exam</span>
              <span className="float-end">
                <i
                  className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'online' ? 'fa-chevron-up' : 'fa-chevron-down'
                    }`}
                ></i>
              </span>
            </div>

            {openDropdown === 'online' && (
              <div className="sidepanel-submenu">
                {/* <p
                  className={`sidepanel-item ${isActive('/admin/question-group') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/question-group');
                    setCollapsed(false);
                  }}
                >
                  <MdOutlineAssignment size={21} />
                  <Link className="sidepanel-text">Question Group</Link>
                </p> */}
                <p
                  className={`sidepanel-item ${isActive('/admin/question-bank') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/question-bank');
                    setCollapsed(false);
                  }}
                >
                  <AiOutlineQuestionCircle size={21} />
                  <Link className="sidepanel-text">Question Bank</Link>
                </p>
                <p
                  className={`sidepanel-item ${isActive('/admin/create-exam') ? 'active' : ''}`}
                  onClick={() => {
                    navigate('/admin/create-exam');
                    setCollapsed(false);
                  }}
                >
                  <IoCreateOutline size={21} />
                  <Link className="sidepanel-text">Create Exam</Link>
                </p>

              </div>
            )}


            {/* HR */}
            {/* ------------------------------------- */}
            <p className='sidepanel-divider'>HR</p>
            {/* employee */}
{userData.role != 'Teacher' && <>

            <div className={`sidepanel-item ${isEmployeeActive() ? 'active' : ''}`} onClick={() => toggleDropdown('employee')}>
              <i className="fa-solid fa-person-chalkboard"></i>
              <span className='sidepanel-text'>Employee</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'employee' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'employee' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/all-employees') ? 'active' : ''}`} onClick={() => { navigate('/admin/all-employees'); setCollapsed(false) }}><PiChalkboardTeacher size={22} /><Link className='sidepanel-text'>All Employees</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/add-employee') ? 'active' : ''}`} onClick={() => { navigate('/admin/add-employee'); setCollapsed(false) }}><AiOutlineUsergroupAdd size={22} /><Link className='sidepanel-text'>Add New</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/staff-icards') ? 'active' : ''}`} onClick={() => { navigate('/admin/staff-icards'); setCollapsed(false) }}><IoIdCardOutline size={21} /><Link className='sidepanel-text'>Staff ID Cards</Link></p>
              </div>
            )}
</>}

{/* Leave Management */}
            <div
              className={`sidepanel-item ${isLeaveActive() ? 'active' : ''}`}
              onClick={() => toggleDropdown('leave')}
            >
              <i className="fa-solid fa-person-walking-arrow-right"></i>
              <span className="sidepanel-text">Leave</span>
              <span className="float-end">
                <i
                  className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'leave' ? 'fa-chevron-up' : 'fa-chevron-down'
                    }`}
                ></i>
              </span>
            </div>

            {openDropdown === 'leave' && (
              <div className="sidepanel-submenu">
                {userData.role != 'SupAdmin' &&
                <p
                  className={`sidepanel-item ${isActive('/admin/apply-leave') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/apply-leave');
                    setCollapsed(false);
                  }}
                >
                  <LuHotel size={21} />
                  <Link className="sidepanel-text">Apply Leave</Link>
                </p>
}

{userData.role != 'Teacher' && <>

                <p
                  className={`sidepanel-item ${isActive('/admin/approve-leave-request') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/approve-leave-request');
                    setCollapsed(false);
                  }}
                >
                  <BiUserCheck size={21} />
                  <Link className="sidepanel-text">Approve Leave Request</Link>
                </p>

                <p
                  className={`sidepanel-item ${isActive('/admin/leave-define') ? 'active' : ''
                    }`}
                  onClick={() => {
                    navigate('/admin/leave-define');
                    setCollapsed(false);
                  }}
                >
                  <MdOutlineAssignment size={21} />
                  <Link className="sidepanel-text">Leave Define</Link>
                </p>

</>
}

              </div>
            )}


            {/* Payroll */}
            {userData.role != 'Teacher' &&
            <p className={`sidepanel-item ${isActive('/admin/payroll') ? 'active' : ''}`} onClick={() => { navigate('/admin/payroll'); setCollapsed(false) }}><MdManageSearch size={21} /><Link className='sidepanel-text'>Payroll</Link></p>}


            {/* utilities */}
            {/* ------------------------------------- */}
            <p className='sidepanel-divider'>Utilities</p>

            {/* visits/ meetings */}
            <div className={`sidepanel-item ${isVisitsActive() ? 'active' : ''}`} onClick={() => toggleDropdown('visits')}>
              <i className="fa-solid fa-clock"></i>
              <span className='sidepanel-text'>Visits/ Meetings</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ${openDropdown === 'visits' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'visits' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/appointments') ? 'active' : ''}`} onClick={() => { navigate('/admin/appointments'); setCollapsed(false) }}><BsBookmarkPlus size={21} /><Link className='sidepanel-text'>Appointments</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/visitor-book') ? 'active' : ''}`} onClick={() => { navigate('/admin/visitor-book'); setCollapsed(false) }}><BsJournalBookmark size={21} /><Link className='sidepanel-text'>Visitor Book</Link></p>
              </div>
            )}



            <p className={`sidepanel-item ${isActive('/admin/grievances') ? 'active' : ''}`} onClick={() => { navigate('/admin/grievances'); setCollapsed(false) }}><i class="fa-solid fa-info"></i><Link className='sidepanel-text'>Grievances</Link></p>

{userData.role != 'Teacher' &&
            <p className={`sidepanel-item ${isActive('/admin/notice-board') ? 'active' : ''}`} onClick={() => { navigate('/admin/notice-board'); setCollapsed(false) }}><PiNotepadLight size={21} /><Link className='sidepanel-text'>Notice Board</Link></p>}


            {/* settings */}
            {/* ------------------------------------- */}
                        {userData.role != 'Teacher' && <>

            <p className='sidepanel-divider'>Settings</p>
            {/* General settings */}

            <div className={`sidepanel-item ${isGeneralActive() ? 'active' : ''}`} onClick={() => toggleDropdown('general')}>
              <i className="fa-solid fa-cog"></i>
              <span className='sidepanel-text'>General Settings</span>
              <span className='float-end'>
                <i className={`fa-solid sidepanel-icon ms-4 ${openDropdown === 'general' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
            </div>
            {openDropdown === 'general' && (
              <div className='sidepanel-submenu'>
                <p className={`sidepanel-item ${isActive('/admin/profile') ? 'active' : ''}`} onClick={() => { navigate('/admin/profile'); setCollapsed(false) }}><i class="fa-regular fa-user"></i><Link className='sidepanel-text'>School Profile</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/academic-year') ? 'active' : ''}`} onClick={() => { navigate('/admin/academic-year'); setCollapsed(false) }}><HiOutlineAcademicCap size={21} /><Link className='sidepanel-text'>Academic Year</Link></p>
                <p className={`sidepanel-item ${isActive('/admin/account-detail') ? 'active' : ''}`} onClick={() => { navigate('/admin/account-detail'); setCollapsed(false) }}><i class="fa-solid fa-credit-card"></i><Link className='sidepanel-text'>Accounts for Fees</Link></p>
       
                {/* <p className={`sidepanel-item`} onClick={() => { setShowLogout(true) }}><i class="fa-solid fa-power-off"></i><Link className='sidepanel-text'>Log Out</Link></p> */}
              </div>
            )}
</>
}

            {/* <p className={`sidepanel-item ${isActive('/admin/other-modules') ? 'active' : ''}`} onClick={() => { navigate('/admin/other-modules'); setCollapsed(false) }}><MdDashboard size={21} /><Link className='sidepanel-text'>Log Out</Link></p> */}
            {/* <p  className={`sidepanel-item ${isActive('/admin/') ? 'active' : ''}`} onClick={() => { navigate('/alumni-posts'); setCollapsed(false) }}><i class="fa-regular fa-envelope"></i><Link className='sidepanel-text'>Alumni Blogs</Link></p> */}
            </>}

            <p className={`sidepanel-item ${isActive('/admin/') ? 'active' : ''}`} onClick={() => { setShowLogout(true) }}><i class="fa-solid fa-power-off"></i><Link className='sidepanel-text'>Log Out</Link></p>

          </div>
        )}

      </div>
      <span className="sidepanel-btn2" onClick={toggleSidebar}>
        <i className={`fa-solid ${collapsed ? "fa-angle-right" : "fa-angle-left"}`}></i>
      </span>

      {showLogout && (

        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-5 col-md-8 col-sm-10 animate__animated animate__fadeInDown mx-auto text-center' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading'>Really want to Log Out?</p>

            <button className='profile-btn me-2' onClick={() => handleLogout()}>Yes</button>
            <button className='profile-btn2' onClick={() => setShowLogout(false)}>No</button>

          </div>
        </section>
      )}
    </>
  )
}

export default SidePanel
